import { gql } from '@efficiently/client-core-graphql-models';

export const DELETE_PLAN_VERSION = gql(`
	mutation DeletePlanVersion($planId: String!, $versionId: String!) {
		deletePlanVersion(planId: $planId, versionId: $versionId)
	}
`);
